import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTreeModule } from '@angular/material/tree';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { DocViewerComponent } from './doc-viewer.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MaterialModule } from '../../core/material/material.module';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { DocViewerRightPanelComponent } from './doc-viewer-right-panel/doc-viewer-right-panel.component';
import { DocViewerContentComponent } from './doc-viewer-content/doc-viewer-content.component';
import { DocViewerOriginalContentComponent } from './doc-viewer-content/doc-viewer-original-content/doc-viewer-original-content.component';
import { DocViewerHtmlContentComponent } from './doc-viewer-content/doc-viewer-html-content/doc-viewer-html-content.component';
import { DocViewerPageContentComponent } from './doc-viewer-content/doc-viewer-page-content/doc-viewer-page-content.component';
import { DocViewerPdfContentComponent } from './doc-viewer-content/doc-viewer-pdf-content/doc-viewer-pdf-content.component';
import { DocViewerTextContentComponent } from './doc-viewer-content/doc-viewer-text-content/doc-viewer-text-content.component';
import { DocViewerProducedContentComponent } from './doc-viewer-content/doc-viewer-produced-content/doc-viewer-produced-content.component';
import { DocViewerTranslatedContentComponent } from './doc-viewer-content/doc-viewer-translated-content/doc-viewer-translated-content.component';
import { DocViewerRedactionContentComponent } from './doc-viewer-content/doc-viewer-redaction-content/doc-viewer-redaction-content.component';
import { DocViewerAnnotationContentComponent } from './doc-viewer-content/doc-viewer-annotation-content/doc-viewer-annotation-content.component';
import { DocViewerCompareContentComponent } from './doc-viewer-content/doc-viewer-compare-content/doc-viewer-compare-content.component';
import { DocViewerCodingTabComponent } from './doc-viewer-right-panel/doc-viewer-coding-tab/doc-viewer-coding-tab.component';
import { DocViewerDocTabComponent } from './doc-viewer-right-panel/doc-viewer-doc-tab/doc-viewer-doc-tab.component';
import { DocViewerEditorTabComponent } from './doc-viewer-right-panel/doc-viewer-editor-tab/doc-viewer-editor-tab.component';
import { RelatedTabBaseComponent } from './doc-viewer-context-panel-template/related-tab-base.component';
import { DocViewerContextPanelComponent } from './doc-viewer-context-panel/doc-viewer-context-panel.component';
import { DocViewerRoutingModule } from "./doc-viewer-routing.module";
import { DocViewerActionBarComponent } from './doc-viewer-action-bar/doc-viewer-action-bar.component';
import { DocViewerInformationBarComponent } from './doc-viewer-information-bar/doc-viewer-information-bar.component';
import { DocViewerBottomRightBarComponent } from './doc-viewer-bottom-right-bar/doc-viewer-bottom-right-bar.component';
import { ActionPanelComponent } from './doc-viewer-bottom-right-bar/action-panel/action-panel.component';
import { TranslateActionPanelComponent } from './doc-viewer-bottom-right-bar/translate-action-panel/translate-action-panel.component';
import { DocViewerCodingSectionComponent } from "./doc-viewer-right-panel/doc-viewer-coding-tab/doc-viewer-coding-section/doc-viewer-coding-section.component";
import { BuiltInCodingSectionComponent } from './doc-viewer-right-panel/doc-viewer-coding-tab/built-in-coding-section/built-in-coding-section.component';
import { CustomCodingSectionComponent } from './doc-viewer-right-panel/doc-viewer-coding-tab/custom-coding-section/custom-coding-section.component';
import { SplitDocPanelComponent } from './doc-viewer-bottom-right-bar/split-doc-panel/split-doc-panel.component';
import { FactsAndIssuesPanelComponent } from './doc-viewer-bottom-right-bar/facts-and-issues-panel/facts-and-issues-panel.component';
import { DocNotePanelComponent } from './doc-viewer-bottom-right-bar/doc-note-panel/doc-note-panel.component';
import { FlatButtonComponent } from './form-controls/flat-button/flat-button.component';
import { DocViewerContextPanelListComponent } from './doc-viewer-context-panel-template/doc-viewer-context-panel-list.component';
import { ReviewContextPanelComponent } from './doc-viewer-context-panel-template/review-context-panel/review-context-panel.component';
import { BrowseContextPanelComponent } from './doc-viewer-context-panel-template/browse-context-panel/browse-context-panel.component';
import { ExactDuplicateContextPanelComponent } from './doc-viewer-context-panel-template/exact-duplicate-context-panel/exact-duplicate-context-panel.component';
import { NearDuplicateContextPanelComponent } from './doc-viewer-context-panel-template/near-duplicate-context-panel/near-duplicate-context-panel.component';
import { EmailFamilyContextPanelComponent } from './doc-viewer-context-panel-template/email-family-context-panel/email-family-context-panel.component';
import { EmailThreadingContextPanelComponent } from './doc-viewer-context-panel-template/email-threading-context-panel/email-threading-context-panel.component';
import { ContextPanelOptionComponent } from './doc-viewer-context-panel/context-panel-option/context-panel-option.component';
import { ExportDocumentPanelComponent } from './doc-viewer-bottom-right-bar/export-document-panel/export-document-panel.component';
import { TextInputComponent } from './form-controls/text-input/text-input.component';
import { SplitSubPanelComponent } from './doc-viewer-context-panel-template/split-sub-panel/split-sub-panel.component';
import { DocNodeComponent } from './doc-viewer-context-panel/doc-node/doc-node.component';
import { DocNavigationListComponent } from './doc-viewer-context-panel/doc-navigation-list/doc-navigation-list.component';
import { CheckboxComponent } from './form-controls/checkbox/checkbox.component';
import { DocValidationMessageComponent } from './doc-viewer-context-panel/doc-validation-message/doc-validation-message.component';
import { DocComparePanelComponent } from "./doc-viewer-bottom-right-bar/doc-compare-panel/doc-compare-panel.component";
import { DocViewerDialogComponent } from "./dialogs/doc-viewer-dialog/doc-viewer-dialog.component";
import { DocViewerHistoryDialogComponent } from "./dialogs/doc-viewer-history-dialog/doc-viewer-history-dialog.component";
import { DocViewerConnectionsDialogComponent } from './dialogs/doc-viewer-connections-dialog/doc-viewer-connections-dialog.component';
import { DocViewerSettingsDialogComponent } from './dialogs/doc-viewer-settings-dialog/doc-viewer-settings-dialog.component';
import { ManualUploadDialogComponent } from './dialogs/manual-upload-dialog/manual-upload-dialog.component';
import { OkCancelDialogNewComponent } from './dialogs/ok-cancel-dialog-new/ok-cancel-dialog-new.component';
import { IconButtonComponent } from './form-controls/icon-button/icon-button.component';
import { CustomAiPromptDialogComponent } from './dialogs/custom-ai-prompt-dialog/custom-ai-prompt-dialog.component';
import { OpenAiSettingDialogNewComponent } from './dialogs/open-ai-setting-dialog-new/open-ai-setting-dialog-new.component';
import { DocViewerAddCodingFieldComponent } from './dialogs/doc-viewer-add-coding-field/doc-viewer-add-coding-field.component';
import { DocViewerCoPilotComponent } from './doc-viewer-bottom-panel/doc-viewer-co-pilot/doc-viewer-co-pilot.component';
import { HitsPanelComponent } from './doc-viewer-bottom-right-bar/hits-panel/hits-panel.component';
import { DrawBoxComponent } from './doc-viewer-content/doc-viewer-redaction-content/draw-box/draw-box.component';
import { RedactionListComponent } from './doc-viewer-right-panel/doc-viewer-editor-tab/redaction-list/redaction-list.component';
import { AnnotationListComponent } from './doc-viewer-right-panel/doc-viewer-editor-tab/annotation-list/annotation-list.component';
import { MultiDocEditComponent } from './dialogs/multi-doc-edit/multi-doc-edit.component';
import { FolderTreeViewNewComponent } from './dialogs/multi-doc-edit/folder-tree-view-new/folder-tree-view-new.component';
import { OptionButtonComponent } from './form-controls/option-button/option-button.component';
import { EditInputComponent } from './form-controls/edit-input/edit-input.component';
import { EmailEditComponent } from './dialogs/email-edit/email-edit.component';
import { EditDateInputComponent } from './form-controls/edit-date-input/edit-date-input.component';
import { PdfViewerComponent } from './doc-viewer-content/doc-viewer-pdf-content/pdf-viewer/pdf-viewer.component';
import { DocViewerBottomPanelComponent } from "./doc-viewer-bottom-panel/doc-viewer-bottom-panel.component";
import { ResizableDirective } from "../../directives/resizable.directive";
import { PromptItemComponent } from "./doc-viewer-bottom-panel/prompt-item/prompt-item.component";
import { PromptResponseComponent } from "./doc-viewer-bottom-panel/prompt-response/prompt-response.component";
import { MarkdownToSafeHtmlPipe } from "../../pipes/markdown-to-safe-html.pipe";
import { ProgressiveTypingDirective } from "../../directives/progressive-typing.directive";
import { MarkdownPipe } from "../../pipes/markdown.pipe";
import { DocViewerSummaryComponent } from "./doc-viewer-bottom-panel/doc-viewer-summary/doc-viewer-summary.component";

@NgModule({
	declarations: [
		DocViewerComponent,
		AccessDeniedComponent,
		DocViewerRightPanelComponent,
		DocViewerContentComponent,
		DocViewerOriginalContentComponent,
		DocViewerHtmlContentComponent,
		DocViewerPageContentComponent,
		DocViewerPdfContentComponent,
		DocViewerTextContentComponent,
		DocViewerProducedContentComponent,
		DocViewerTranslatedContentComponent,
		DocViewerRedactionContentComponent,
		DocViewerAnnotationContentComponent,
		DocViewerCompareContentComponent,
		DocViewerCodingTabComponent,
		DocViewerDocTabComponent,
		DocViewerEditorTabComponent,
		RelatedTabBaseComponent,
		DocViewerContextPanelComponent,
		DocViewerActionBarComponent,
		DocViewerInformationBarComponent,
		DocViewerBottomRightBarComponent,
		ActionPanelComponent,
		TranslateActionPanelComponent,
		DocViewerCodingSectionComponent,
		BuiltInCodingSectionComponent,
		CustomCodingSectionComponent,
		SplitDocPanelComponent,
		FactsAndIssuesPanelComponent,
		DocNotePanelComponent,
		FlatButtonComponent,
		DocViewerContextPanelListComponent,
		ReviewContextPanelComponent,
		BrowseContextPanelComponent,
		ExactDuplicateContextPanelComponent,
		NearDuplicateContextPanelComponent,
		EmailFamilyContextPanelComponent,
		EmailThreadingContextPanelComponent,
		ContextPanelOptionComponent,
		ExportDocumentPanelComponent,
		TextInputComponent,
		SplitSubPanelComponent,
		DocNodeComponent,
		DocNavigationListComponent,
		CheckboxComponent,
		DocValidationMessageComponent,
		DocComparePanelComponent,
		DocValidationMessageComponent,
		DocViewerDialogComponent,
		DocViewerHistoryDialogComponent,
		DocViewerConnectionsDialogComponent,
		DocViewerSettingsDialogComponent,
		ManualUploadDialogComponent,
		OkCancelDialogNewComponent,
		IconButtonComponent,
		CustomAiPromptDialogComponent,
		OpenAiSettingDialogNewComponent,
		DocViewerAddCodingFieldComponent,
		DocViewerCoPilotComponent,
		RedactionListComponent,
		DrawBoxComponent,
		HitsPanelComponent,
		AnnotationListComponent,
		MultiDocEditComponent,
		FolderTreeViewNewComponent,
		OptionButtonComponent,
		EditInputComponent,
		EmailEditComponent,
		EditDateInputComponent,
		PdfViewerComponent,
		DocViewerBottomPanelComponent,
		PromptResponseComponent,
		DocViewerSummaryComponent,
	],
    exports: [
        DocViewerCoPilotComponent,
        FlatButtonComponent,
        PromptResponseComponent,
        TextInputComponent
    ],
	imports: [
		MaterialModule,
		MatSortModule,
		MatDatepickerModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatTreeModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		DragDropModule,
		ScrollingModule,
		CdkTableModule,
		CdkTreeModule,
		A11yModule,
		NgxSkeletonLoaderModule,
		DocViewerRoutingModule,
		ResizableDirective,
		PromptItemComponent,
		MarkdownToSafeHtmlPipe,
		MarkdownPipe,
		ProgressiveTypingDirective,
	]
})
export class DocViewerModule {
}
